import React from "react";

interface RegenerateIconProps {
    width?: string;
    height?: string;
    fill?: string;
    stroke?: string;
    onClick?: () => void;
    className?: string;
}

const RegenerateIcon: React.FC<RegenerateIconProps> = ({
    width = "28",
    height = "28",
    fill = "none",
    stroke = "currentColor",
    onClick,
    className
}) => (
    <svg width="17" height="17" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.53377 0.108248C10.7081 -0.214304 12.9286 0.18868 14.8511 1.25439C16.1809 1.99161 17.3168 3.01776 18.1816 4.24715V2.73079C18.1817 2.22879 18.5887 1.82169 19.0908 1.82169C19.5928 1.82175 19.9999 2.22883 20 2.73079V6.3672C20 6.86924 19.5929 7.27624 19.0908 7.2763H15.454C14.9519 7.2763 14.5448 6.86928 14.5448 6.3672C14.5449 5.8652 14.9519 5.4581 15.454 5.4581H16.8054C16.0851 4.37935 15.1161 3.48012 13.9694 2.84443C12.3964 1.97246 10.5792 1.64298 8.80014 1.90692C7.0212 2.17092 5.37909 3.01386 4.12716 4.30485C2.87518 5.59593 2.0827 7.26308 1.8737 9.04923C1.6647 10.8354 2.05014 12.6408 2.97024 14.186C3.89038 15.7312 5.29477 16.9303 6.96487 17.5978C8.63478 18.2651 10.478 18.3636 12.2096 17.8783C13.9415 17.393 15.4653 16.3504 16.5452 14.9122C16.8467 14.5109 17.417 14.4297 17.8185 14.7311C18.2199 15.0325 18.301 15.6027 17.9996 16.0042C16.6797 17.7619 14.8173 19.0359 12.7006 19.6291C10.584 20.2223 8.3304 20.1013 6.28918 19.2855C4.2483 18.4697 2.53296 17.0047 1.40844 15.1164C0.283832 13.2278 -0.187725 11.021 0.0677253 8.83793C0.323168 6.65493 1.29095 4.61681 2.82108 3.03886C4.35132 1.46087 6.35934 0.430844 8.53377 0.108248Z" fill="currentColor" />
    </svg>

);

export default RegenerateIcon;
